// Vue mixin för alla sidor i SSO:

import Vue from 'vue';

// Vue mixins:

import { euiLifecycleStatusesMixin } from 'v-mixins/euiLifecycleStatusesMixin';

// Vue directives:

//import euiAutofocus from 'v-directives/euiAutofocus';
////euiAutofocus.registreraDirektivet();
//euiAutofocus.registerDirectiveGlobally();

/* eslint-disable import/first */

import euiMaintainDisabled from 'v-directives/euiMaintainDisabled';

import euiMedAktuellSidaDetektering from 'v-directives/euiMedAktuellSidaDetektering';
euiMedAktuellSidaDetektering.registerDirectiveGlobally();

//import highlight from 'vue-highlight-text/public/directive.min';
//Vue.directive('highlight', highlight);

// Vue components:
import { euiSwitch } from 'v-components/euiSwitch';

// todo: TEMP!!!!
//import appProps from 'v-components/ssoAppProps'
//import appDataFromMvcView from 'v-components/appDataFromMvcView';

//import euiBurgare.component as euiBurgare from 'v-components/euiBurgare';
import euiBurgare from 'v-components/euiBurgare';
//import licensedropdown from 'v-components/euiLicenseDropdown.vue';
//import companydropdown from 'v-components/euiCompanyDropdown.vue';
//import fiscalyeardropdown from 'v-components/euiFiscalYearDropdown.vue';
//import monthselector from 'v-components/euiMonthSelector.vue';
import autocomplete from 'v-components/euiAutocomplete.vue';
import searchtext from 'v-components/euiSearchText.vue';
import euiHjalpknapp from 'v-components/euiHjalpknapp.vue';
//import { ssoAddPageKnapp } from 'ssoAddPageKnapp';
import { ssoTooltips } from 'ssoTooltips';
import NavigatedWithBackOrForward from 'NavigatedWithBackOrForward';
import throttla from 'lodash.throttle';

import euiModifieradSvg from 'v-components/euiModifieradSvg';
import euiKnapp from 'v-components/euiKnapp';

import euiPopUpMenyClasses from 'v-components/classes/euiPopUpMenyClasses';
import euiMermeny from 'v-components/euiMermeny';

import euiDialogClasses from 'v-components/classes/euiDialogClasses';
import euiDialog from 'v-components/euiDialog';
import euiMeddelandedialog from 'v-components/euiMeddelandedialog';

import Notifications from 'vue-notification';

// Vue store:
import { ssoStatestore as store } from 'v-store/ssoStatestore';	// 'store' för jag vet inte om/hur jag kan använda ett annat namn nedan :(
import { mapState } from 'vuex';

// Övrigt:
import axios from 'axios';
import axiosErrorTextHtml from 'axiosErrorTextHtml';
import objectToFormData from 'object-to-formdata';
import { Resultat } from 'classes/ResultatClasses';
import { VueLoading } from 'vue-loading-template';

//// Bakkanal via websockets
//import VueSocketIO from 'vue-socket.io'


////Vue.use(VueSocketIO, 'http://socketserver.com:1923'); // Automaticly socket connect from url string

//Vue.use(new VueSocketIO({
//	debug: true,
//	connection: 'http://127.0.0.1:27416',
//	vuex: {
//		store,
//		actionPrefix: 'SOCKET_',
//		mutationPrefix: 'SOCKET_'
//	},
//	options: { path: '/my-app/' } //Optional options
//}));





//// make sure to set this synchronously immediately after loading Vue
//Vue.config.devtools = true;
//console.log(Vue.config.devtools);
//Vue.config.silent = false;
//console.log(Vue.config.silent);
////Vue.config.errorHandler = function (err, vm, info) {
////	// handle error
////	// `info` is a Vue-specific error info, e.g. which lifecycle hook
////	// the error was found in. Only available in 2.2.0+
////	console.error(err, info, vm);
////};
//// Assign a custom handler for runtime Vue warnings. Note this only works during development and is ignored in production:
////Vue.config.warnHandler = function (msg, vm, trace) {
////	// `trace` is the component hierarchy trace
////}




// Använd dessa Vue plugins:
Vue.use(Notifications);
Vue.use(euiSwitch);


window.ssoAllaSidor = window.ssoAllaSidor || {};	// För att undvika ESLint-varningar att den är odefinierad.
window.ssoRamverk = window.ssoRamverk || {};	// För att undvika ESLint-varningar att den är odefinierad.


//------------------------------------------------------------------------------------------------------------------------------

const mixin = {

	//sockets: {
	//	connect: function () {
	//		console.log('socket connected')
	//	},
	//	customEmit: function (val) {
	//		console.log('this method fired by socket server. eg: io.emit("customEmit", data)')
	//	}
	//},
	components: {
		// todo: TEMP!!!!
		//[appProps.component.name]: appProps.component,
		//appDataFromMvcView,

		[euiBurgare.component.name]: euiBurgare.component,
		'eui-autocomplete': autocomplete,
		'eui-searchtext': searchtext,
		euiHjalpknapp,
		euiModifieradSvg,
		euiKnapp,
		euiMermeny,
		'vue-loading': VueLoading,		// Anv i meddelande om att uppladdning pågår.
		euiMeddelandedialog,
		euiDialog,
	},

	store,	// ssoStatestore

	mixins: [euiLifecycleStatusesMixin],

	directives: {
		//	'autofocus': euiAutofocus.directive,
		[euiMaintainDisabled.name]: euiMaintainDisabled,
	},

	data() {
		return {
			//! Temp test:
			//appDataFromMvcView: undefined,

			sidanInaktiveradMedFullOpacitetOchSpinnerVisasEfterXs: false,
			doldMenyArOppnad: false,
			fonstretArSmalt: false,


			// Från ssoAllaSidor (laddas också om via polling!):

			disableRichContextPoll: window.ssoAllaSidor.disableRichContextPoll || false,
			checkThatCompanyAndFiscalYearAreSelected: window.ssoAllaSidor.checkThatCompanyAndFiscalYearAreSelected,

			menydataHash: '',
			appVersion: window.ssoAllaSidor.appVersion,

			uploadStatus: window.ssoAllaSidor.uploadStatus,
			timestamp: window.ssoAllaSidor.timestamp,
			//uploadInProgress: window.ssoAllaSidor.uploadInProgress,

			autovisaMeddelande: window.ssoAllaSidor.autovisaMeddelande,

			licenses: window.ssoAllaSidor.licenses,
			licenseIsSelected: window.ssoAllaSidor.licenseIsSelected,
			selectedLicenseId: window.ssoAllaSidor.selectedLicenseId,
			selectedLicenseName: window.ssoAllaSidor.selectedLicenseName,
			selectedLicenseOwnersNameAndLicenseNumber: window.ssoAllaSidor.selectedLicenseOwnersNameAndLicenseNumber,
			selectedLicenseOrNotSelectedPresentationHtml: window.ssoAllaSidor.selectedLicenseOrNotSelectedPresentationHtml,

			companies: window.ssoAllaSidor.companies,
			companyIsSelected: window.ssoAllaSidor.companyIsSelected,
			selectedCompanyId: window.ssoAllaSidor.selectedCompanyId,
			selectedCompanyName: window.ssoAllaSidor.selectedCompanyName,
			selectedCompanyOrNotSelectedPresentationHtml: window.ssoAllaSidor.selectedCompanyOrNotSelectedPresentationHtml,

			fiscalYears: window.ssoAllaSidor.fiscalYears,
			fiscalYearIsSelected: window.ssoAllaSidor.fiscalYearIsSelected,
			selectedFiscalYearId: window.ssoAllaSidor.selectedFiscalYearId,
			selectedFiscalYearOrNotSelectedPresentationHtml: window.ssoAllaSidor.selectedFiscalYearOrNotSelectedPresentationHtml,

			months: window.ssoAllaSidor.months,

			accounts: window.ssoAllaSidor.accounts,

			currentUser: window.ssoAllaSidor.currentUser,
			currentUserName: window.ssoAllaSidor.currentUserName,
			currentUserEmail: window.ssoAllaSidor.currentUserEmail,
			currentUserGravatarUrl: window.ssoAllaSidor.currentUserGravatarUrl,

			impersonatedByUserNameOrNotImpersonatingPresentationHtml: window.ssoAllaSidor.impersonatedByUserNameOrNotImpersonatingPresentationHtml,

			// Flyttad till window.ssoOversikt:
			//dashboardPages: window.ssoAllaSidor.dashboardPages,

			//modalcontainer: this.$refs.modalcontainer,

			isPowerUser: window.ssoAllaSidor.isPowerUser,
			// Utgått enl spec: isSuperUser: window.ssoAllaSidor.isSuperUser,
			isAdministrator: window.ssoAllaSidor.isAdministrator,
			isSupportPerson: window.ssoAllaSidor.isSupportPerson,
			isImpersonating: window.ssoAllaSidor.isImpersonating,




			// --------

			// Ful Q&D för att få getterns cacheade värde invaliderat vid set:
			recomputeArIRedigeralage: undefined,

			snabbvalComponent: null,
			sokComponent: null,

			menyLicens: undefined,		// Sätts i lifecycle hook created, nedan
			menyForetag: undefined,		// Sätts i lifecycle hook created, nedan
			menyRar: undefined,		// Sätts i lifecycle hook created, nedan

			menyAnvandare: undefined,		// Sätts i metod istället. Första anrop i lifecycle hook created, nedan
			//new euiPopUpMenyClasses.menyConfig([
			//	new euiPopUpMenyClasses.delLinje(),
			//	new euiPopUpMenyClasses.delLank('Min profil', '/installningar/min-profil', { ikon: 'anvandare' }),
			//	//new euiPopUpMenyClasses.delLank('Mitt konto', '/installningar/mittkonto', { ikon: 'anvandare' }),

			//	// Resten påverkas av villkor och adderas därför senare...
			//]),
			//
			// Behövs inte längre:
			//visaMenyAnvandare: false,
			doljMenyAnvandareLangsamt: false,

			menyImpersonering: new euiPopUpMenyClasses.menyConfig([
				new euiPopUpMenyClasses.delEvent('Avbryt impersoneringen', 'inimpersonate', { ikon: 'ogaStruket', cssModifierClass: '-fara' })
			]),

			visaMeddelandedialogOm: false,

			dialogStack: [],
			popUpMenyStack: [],

			meddelandedialoger: [],

			//list: [],
			pollTimer: '',
			pendingPollRequest: false,

			// Todo: Test av SSE (Server Side Events):
			sseData: undefined,
		};
	},

	computed: {
		//licensesExceptSelected() {
		//	return this.licenses.filter((b) => { return b.Id !== this.selectedLicenseId + 'KORTSLUTEN!'; });
		//},

		//companiesExceptSelected() {
		//	return this.companies.filter((f) => { return f.Id !== this.selectedCompanyId; });
		//},

		//fiscalYearsExceptSelected() {
		//	return this.fiscalYears.filter((y) => { return y.Id !== this.selectedFiscalYearId; });
		//},

		licenseCompanyAndYear() {
			// "|| ''" nedan för att hantera olika icke-värden (null, "", undefined) lika. MVC view model visade sig servera "" ibland och null ibland. Då triggar det en ändring av denna computed!
			return (this.selectedLicenseId || '')
				+ (this.selectedCompanyId || '')
				+ (this.selectedFiscalYearId || '');
		},

		licensesCount() {
			return this.licenses.length;
		},

		companiesCount() {
			return this.companies.length;
		},

		fiscalYearsCount() {
			return this.fiscalYears.length;
		},

		menynArStangd() {
			return (this.fonstretArSmalt && !this.doldMenyArOppnad);
		},

		// ! Kan inte ersätta getter/setter nedan med mapState, för komponenten <eui-switch> har denna som v-model = skriver till den = setter behövs. Skulle måhända gå att refactora och *ev* skulle det då även bli ett "renare" sätt.
		// Todo: Denna status är egentligen per företag, men persisteras f.n. "globalt" i store:
		arIRedigeralage: {
			// getter
			get() {
				// Ful Q&D för att få getterns cacheade värde invaliderat vid set:
				const slask = this.recomputeArIRedigeralage;

				// Här stänger vi med våld av arIRedigeralage om anv *inte* är poweruser:
				if (!this.isPowerUser) {
					//this.$store.commit('setArIRedigeraLage', false);
					// Save data to sessionStorage (blir alltid string!):
					sessionStorage.setItem('arIRedigeralage', false);
					return false;
				}

				//return this.$store.state.arIRedigeralage;
				// Get saved data from sessionStorage (är alltid string! och null om saknas):
				const rl = sessionStorage.getItem('arIRedigeralage');
				return (rl === 'true');
			},
			// setter
			set(value) {
				//this.$store.commit('setArIRedigeraLage', value);
				// Save data to sessionStorage (blir alltid string!):
				sessionStorage.setItem('arIRedigeralage', value);

				//// Remove saved data from sessionStorage
				//sessionStorage.removeItem('arIRedigeralage');

				//// Remove all saved data from sessionStorage
				//sessionStorage.clear();

				// Ful Q&D för att få getterns cacheade värde invaliderat vid set:
				this.recomputeArIRedigeralage = value;


			}
		},

		dialogVisas() {
			return (this.dialogStack.length > 0);
		},

		bothCompanyAndFiscalYearAreSelected() {
			return this.companyIsSelected && this.fiscalYearIsSelected;
		},

		...mapState([
			// map this.count to store.state.count
			'inloggningsbildNr'
		])
	},

	watch: {

		arIRedigeralage(nyttVarde, tidigareVarde)
		{
			this.doljMenyAnvandareLangsamt = true;
		},

		//uploadInProgress(nyttVarde, tidigareVarde) {
		//	// Både när upload-status inträder och utträder:
		//	// Ladda om sidan så att ValidateContext...-filtret trädet in = man står kvar på samma URL men en alternativ view visas:
		//	this.avbrytPollningen();
		//	window.location.reload(true);
		//},
		uploadStatus(nyttVarde, tidigareVarde) {
			// Både när upload-status inträder och utträder OCH när status på pågående uppladdning ändras:
			// Ladda om sidan så att ValidateContext...-filtret trädet in = man står kvar på samma URL men en alternativ view visas:
			this.avbrytPollningen();
			window.location.reload(true);
		},

		timestamp(nyttVarde, tidigareVarde) {
			// Om uppladdning skett mellan två pollningar så detekteras ingen förändring av uploadStatus. Då fångar vi förändringen av timestamp i stället:
			// Ladda om sidan så att ValidateContext...-filtret trädet in = man står kvar på samma URL men en alternativ view visas:
			console.log('nyttVarde=' + nyttVarde + ', tidigareVarde=' + tidigareVarde);
			this.avbrytPollningen();
			window.location.reload(true);
		},

		bothCompanyAndFiscalYearAreSelected(nyttVarde, tidigareVarde) {
			// Både när denna status inträder och utträder:
			if (this.checkThatCompanyAndFiscalYearAreSelected === true) {
				// Om sidan är en sådan där kontroll att företag & r-år är valt ska ske:
				// Ladda om sidan så att ValidateContext...-filtret trädet in = man står kvar på samma URL men en alternativ view visas:
				this.avbrytPollningen();
				window.location.reload(true);
			}
		},

		doldMenyArOppnad(nyttVarde, tidigareVarde) {
			if (!nyttVarde) {
				// Menyn har stängts:

				if (this.snabbvalComponent) {
					// Om sådan finns:
					// Töm innehållet i Snabbval:
					this.tomInputruta(this.snabbvalComponent.$refs.input);
				}
			}
		},

		licenseCompanyAndYear(nyttVarde, tidigareVarde) {

			// !!!!!!!!! Obs! Denna hanterar förändringar som sker pga pollningen. När användaren i UI själv byter så sker samma navigering direkt, i den koden!

			if (nyttVarde && nyttVarde != '')
			{
				// Om vi bytt byrå, företag eller räkenskapsår så ska vi ladda översiktssidan
				this.avbrytPollningen();
				window.location.href = '/';
			}
		},

		licenses: {
			handler(nyttVarde, tidigareVarde) {
				// Bara om den ändrats! Annars trigger denna reaktivitet vid varje poll:
				if(JSON.stringify(nyttVarde) !== JSON.stringify(tidigareVarde))
				{
					//! Denna skapar om alla 3 menyer från scratch. Ev skulle vi kunna testa vilka förutsättningar som ändrats och bara omskapa efter dessa.
					this.createPopUpMenus();
				}
			},
			deep: true,				// OBS! Deep!
		},

		companies: {
			handler(nyttVarde, tidigareVarde) {
				// Bara om den ändrats! Annars trigger denna reaktivitet vid varje poll:
				if(JSON.stringify(nyttVarde) !== JSON.stringify(tidigareVarde))
				{
					//! Denna skapar om alla 3 menyer från scratch. Ev skulle vi kunna testa vilka förutsättningar som ändrats och bara omskapa efter dessa.
					this.createPopUpMenus();
				}
			},
			deep: true,				// OBS! Deep!
		},

		fiscalYears: {
			handler(nyttVarde, tidigareVarde) {
				// Bara om den ändrats! Annars trigger denna reaktivitet vid varje poll:
				if(JSON.stringify(nyttVarde) !== JSON.stringify(tidigareVarde))
				{
					//! Denna skapar om alla 3 menyer från scratch. Ev skulle vi kunna testa vilka förutsättningar som ändrats och bara omskapa efter dessa.
					this.createPopUpMenus();
				}
			},
			deep: true,				// OBS! Deep!
		},
	},

	methods: {

		//addComponent() {
		//	let idet = this.idet++;
		//	let meddelandeTextEllerHtml = 'Tjohoo! Det funkar ju faktiskt! ' + idet;
		//	this.visaMeddelande(meddelandeTextEllerHtml);
		//},
		//deleteComponent() {
		//	//this.meddelandedialoger.splice(0, 1);
		//	this.meddelandedialoger.pop();
		//},

		visaMeddelande(meddelandeTextEllerHtml,
			// Named and optional parameters (med eventuella default satta), as options object:
			{
				dialogId = null,
				ikon = 'informationsmeddelande',
				ikonCssModifierClass = '-info',	//undefined,	// undefined => default i komponenten slår igenom. null => ingen.
				knappar,		// undefined => bara en enkel OK-knapp.
				breddMedEnhet,		// undefined = defaultbredd
				fotText = '&nbsp;',
			}
				= {}	// Default för den optional options-parametern som sådan.
		) {
			let that = this;

			const renderComponent = {
				render(h) {

					// https://vuejs.org/v2/guide/render-function.html#The-Data-Object-In-Depth
					let dataObject = {
						//class: ['foo'],	// Hamnar bara på .v-portal-elementen (som det är nu)

						props: {
							//vpBreddMedEnhet: '60vw',
							vpDialogId: dialogId,
							vpIkon: ikon,
							vpIkonCssModifierClass: ikonCssModifierClass,
							vpMeddelandeTextEllerHtml: meddelandeTextEllerHtml,
							vpFotText: fotText,
							vpDialogStack: that.dialogStack,
							vpKnappar: knappar,
							vpBreddMedEnhet: breddMedEnhet,
						},

						//on: {
						//	'meddelandedialog-inaktiverad-och-stangd': () => { that.meddelandedialoger.pop(); },
						//},
					};

					// sync properties are just sugar for a prop and a handler
					// for `updated:prop`. So here we add the prop and the handler.
					//def.on[`update:${sync}`] = val => this[sync] = val
					//def.props[sync] = this[template.sync[sync]]

					return h(euiMeddelandedialog, dataObject);
				}
			};

			this.meddelandedialoger.push(renderComponent);
		},

		visaResultatmeddelande(resultat,
			// Named and optional parameters (med eventuella default satta), as options object:
			{
				dialogId = null,
				breddMedEnhet,		// undefined = defaultbredd
			}
				= {}	// Default för den optional options-parametern som sådan.
		) {
			// Först lite basic typkontroller av parametrarna: ---------------------------

			console.assert(!!resultat && resultat instanceof Resultat,
				'Parametern \'resultat\' är obligatorisk och måste vara av typen \'Resultat\'.'
			);

			console.assert(!dialogId || typeof dialogId === 'string',
				'Parametern \'dialogId\' måste vara av typen \'string\' (eller null/undefined).'
			);

			console.assert(!breddMedEnhet || typeof breddMedEnhet === 'string',
				'Parametern \'breddMedEnhet\' måste vara av typen \'string\' (eller undefined, *inte* null).'
			);

			// ---------------------------------------------------------------------------

			const ikon = (resultat.Failed ? 'felmeddelande' : 'lyckatmeddelande');
			const ikonCssModifierClass = (resultat.Failed ? '-fara' : '-lyckat');

			if (!dialogId
				&& (resultat.Messages[0].Code.startsWith('ladda-om-sidan')
					|| resultat.Messages[0].Code.startsWith('inte-inloggad')
				)
			) {
				// Om dialogId inte redan är satt till nåt annat
				// OCH meddelandet har för ändamålet särskild special-code:
				// Sätt dialogId till en annan special-kod som betyder att efter meddelandet stängts så ska sidan laddas om:
				dialogId = 'innanOmladdningAvSidan';
			}

			let messagesTextHtml = resultat.AllMessagesAsHtml;

			if (resultat.Failed
				&& resultat.Messages[0].ExceptionType
			)
			{
				// Om det är en exception:
				// Komplettera meddelandet med "Interna uppgifter för felsökning":
				const nu = new Date(Date.now()).toISOString();

				messagesTextHtml += `
<p class="liten -morkgra-text">
	Interna uppgifter för felsökning:
	<br><b>Tidpunkt:</b> ${nu}
	<br><b>Kod:</b> ${resultat.Messages[0].Code}
	<br><b>Typ av undantag:</b> ${resultat.Messages[0].ExceptionType}
</p>
`;
			}

			let fotText = '&nbsp;';

			if (resultat.Messages[0].Code)
				fotText = `
<p class="pytteliten -ljusgra-text" style="position: absolute; bottom: 0;">
	Intern kod: ${resultat.Messages[0].Code}
</p>
`;

			this.visaMeddelande(messagesTextHtml, {
				ikon: ikon,
				ikonCssModifierClass: ikonCssModifierClass,
				fotText: fotText,
				dialogId: dialogId,
				breddMedEnhet: breddMedEnhet,
			});
		},

		visaAxiosFelmeddelande(axiosError) {
			const messagesTextHtml = axiosErrorTextHtml(axiosError);
			this.visaMeddelande(messagesTextHtml, { ikon: 'felmeddelande', ikonCssModifierClass: '-fara' });
		},

		tomInputruta: (el) => {
			el.value = '';
		},

		//fyllInputruta: (el, value) => {
		//	el.value = value;
		//},

		fokuseraInputruta: (el) => {
			el.focus();
		},

		selectaAlltIInputruta: (el) => {
			el.select();
		},

		// Metod för att persistera ett elements scrollTop:
		persisteraScrollTop(vueApp, el) {
			// Schedule the function to run at the start of the frame:
			window.requestAnimationFrame(function () {

				vueApp.$store.commit('setScrollTopForRullningsbartElement', {
					vuexNamespace: vueApp.$_vuexNamespace,
					elementId: el.id,
					nyttScrollTopvarde: el.scrollTop,
				}
				);

			});
		},

		pollContext() {

			// För att inte polla då fönstret/tabben inte visas/är aktivt:
			// https://developer.mozilla.org/en-US/docs/Web/API/Document/hidden
			// https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API
			if (typeof document.hidden !== 'undefined'
				&& document.hidden)
			{
				//console.log('Ingen uppdatering då fönstret/tabben inte visas/är aktivt.')
				return;
			}

			// För att inte trigga dialogmeddelanden om att vi är utloggade om vi är utloggade:
			if (!this.currentUser) {
				//console.log('Ingen uppdatering av menyer, eftersom vi är utloggede.')
				return;
			}

			// För att inte polla då dialog visas:
			if (this.dialogVisas) {
				//console.log('Ingen uppdatering av menyer, eftersom dialogruta visas.')
				return;
			}

			// För att inte polla om pollning redan pågår:
			if (this.pendingPollRequest) {
				//console.log('Ingen uppdatering av menyer, eftersom vi har en pending poll request.')
				return;
			}


			// Timer event för att uppdatera menyalternativen om de skulle ha ändrats
			//console.log('Timer event');

			this.pendingPollRequest = true;		// Semaforera att vi har en utestående poll request så att vi
															// avstår från ytterligare poll requests tills dess att vi fått svar
															// från den första

			this.AjaxpostaOchHanteraResultat('/menydata', {
				formData: objectToFormData({ forraMenydataHash: this.menydataHash }),
				withoutSpinner: true, // Detta är async så det ska inte synas

				onFailureFunction: (resultat) => {
					// Måste finnas, för pendingPollRequerst ska nollas!

					// På prov visar vi inte sådana här fel, utan det blir helt osynligt för användaren:
					//this.visaResultatmeddelande(resultat);

					// DOCK, ska vi visa meddelandet i ETT fall, nämligen att man blivit utloggad:
					if (resultat.Messages[0].Code.startsWith('inte-inloggad'))
						this.visaResultatmeddelande(resultat);

					this.pendingPollRequest = false;
				},

				onCatchedErrorFunction: (error) => {
					// Måste finnas, för pendingPollRequerst ska nollas!

					// På prov visar vi inte sådana här fel, utan det blir helt osynligt för användaren:
					//this.visaAxiosFelmeddelande(error);

					this.pendingPollRequest = false;
				},

				onSuccessFunction: (resultat) => {

					if (resultat.CustomData !== null)
					{
						// Om menydata ändrats sedan förra requesten:

						// Har nu hämtat ny RichInfo:

						// ------------------------------- Sätt om appens data med nya värden:

						// Todo: Här borde vi ha en prop för hela RichContext. Kanske som en egen class med castFrom(). OBS!!!! Reaktiviteten på de enskilda proparna i den KAN behöva justeras (deep eller med computed)!

						// Se kommentar i _Huvudscript om denna utkommentering:
						//if (resultat.CustomData.UserInfo) {
							//console.log('uppdaterar SsoUserInfo');
							this.currentUser = resultat.CustomData.UserInfo.Id;
							this.currentUserName = resultat.CustomData.UserInfo.Name;	//WithImpersonation;
							this.currentUserEmail = resultat.CustomData.UserInfo.Email;	//WithImpersonation;
							this.currentUserGravatarUrl = resultat.CustomData.UserGravatarUrl;

							this.impersonatedByUserNameOrNotImpersonatingPresentationHtml = resultat.CustomData.ImpersonatedByUserNameOrNotImpersonatingPresentationHtml;
						//}
						//else {
						//	//console.log('clearar SsoUserInfo');
						//	this.currentUser = undefined;
						//	this.currentUserName = undefined;
						//	this.currentUserEmail = undefined;
						//}

						// Data som behövs för byråval

						this.licenses = resultat.CustomData.Licenses;	// OBS!!!!!! Denna ersätter hela arrayen (by ref) och triggar därmed en reaktivitets-watch! Det hanteras i watchen.

						this.licenseIsSelected = resultat.CustomData.LicenseIsSelected;
						this.selectedLicenseId = resultat.CustomData.SelectedLicenseId;
						this.selectedLicenseName = resultat.CustomData.SelectedLicenseName;
						this.selectedLicenseOwnersNameAndLicenseNumber = resultat.CustomData.selectedLicenseOwnersNameAndLicenseNumber;
						this.selectedLicenseOrNotSelectedPresentationHtml = resultat.CustomData.SelectedLicenseOrNotSelectedPresentationHtml;

						// Data som behövs för företagsval

						this.companies = resultat.CustomData.Companies;	// OBS!!!!!! Denna ersätter hela arrayen (by ref) och triggar därmed en reaktivitets-watch! Det hanteras i watchen.

						this.companyIsSelected = resultat.CustomData.CompanyIsSelected;
						this.selectedCompanyId = resultat.CustomData.SelectedCompanyId;
						this.selectedCompanyName = resultat.CustomData.SelectedCompanyName;
						this.selectedCompanyOrNotSelectedPresentationHtml = resultat.CustomData.SelectedCompanyOrNotSelectedPresentationHtml;

						this.fiscalYears = resultat.CustomData.SelectableFiscalYearsInfo;	// OBS!!!!!! Denna ersätter hela arrayen (by ref) och triggar därmed en reaktivitets-watch! Det hanteras i watchen.

						this.fiscalYearIsSelected = resultat.CustomData.FiscalYearIsSelected;
						this.selectedFiscalYearId = resultat.CustomData.SelectedFiscalYearId;
						this.selectedFiscalYearOrNotSelectedPresentationHtml = resultat.CustomData.SelectedFiscalYearOrNotSelectedPresentationHtml;

						// Månadsval för rapporter
						this.months = resultat.CustomData.SelectableMonths;

						//! Flyttad till HuvudScriptViewModel:
						//// För snabbval
						//this.accounts = resultat.CustomData.Accounts;	//! Behövs inte för att uppdatera menyerna

						// Användarinfo
						this.isPowerUser = resultat.CustomData.IsPowerUser;
						// Utgått enl spec: window.ssoAllaSidor.isSuperUser = resultat.CustomData.IsSuperUser;
						this.isAdministrator = resultat.CustomData.IsLicenseAdministrator;
						this.isSupportPerson = resultat.CustomData.IsSupportPerson;
						this.isImpersonating = resultat.CustomData.IsImpersonating;

						//! Denna är *inte* en del av RichContext!
						// För att kunna flytta widgets mellan sidor
						//this.dashboardPages = resultat.CustomData.DashboardPages;	//! Behövs inte för att uppdatera menyerna

						this.uploadStatus = resultat.CustomData.UploadStatus;
						this.timestamp = resultat.CustomData.Timestamp;
						//this.uploadInProgress = resultat.CustomData.UploadInProgress;

						this.appVersion = resultat.CustomData.AppVersion;

						this.menydataHash = resultat.CustomData.Hash;


						// ------------------------------- Reagera på ev förändringar som inte sker med reaktivitet/watch:

						// Todo: Visst här borde ske medelst watch-reaktivitet:

						// Flyttad till reaktiv (annars ritas webbsidan om vid varje poll!):
						////! Denna skapar on alla menyer från scratch. Ev skulle vi kunna testa vilka förutsättningar som ändrats och bara omskapa efter dessa.
						//this.createPopUpMenus();
					}

					this.pendingPollRequest = false;
				},
			});
		},

		avbrytPollningen() {
			if (!this.disableRichContextPoll) {
				clearInterval(this.pollTimer);
			}
		},

		//#####  Eventhanterare:   #################################################

		//onReloadCache() {
		//	// Nedanstående behövs för att vue-komponenten äter upp klick/toggling och då släcks inte eventuella synliga tooltips:
		//	ssoTooltips.doljAlla();

		//	axios.post('/clearcache', new FormData())
		//		.then(response => {
		//			//? Ev testa respons här?
		//			this.avbrytPollningen();
		//			window.location.reload(true);
		//		})
		//		.catch(e => {
		//			console.error(e);
		//		});
		//},

		// todo: TEMP!!!!
		//getAppPropsObject()
		//{
		//	return this.$children.find(x => x._name === '<AppProps>').propsObject;
		//},

		//getAppPropValue(keyName)
		//{
		//	return this.$children.find(x => x._name === '<AppProps>').propsObject[keyName];
		//},

		onSmaltFonsterAndrat(mediaQueryList) {
			let was = this.fonstretArSmalt;
			this.fonstretArSmalt = (mediaQueryList.matches ? true : false);

			if (was === true && this.fonstretArSmalt === false) {
				// Stäng om öppnad:
				this.doldMenyArOppnad = false;
			}
		},

		//onBeforeUnload: function(event)
		//{
		//	alert('Leeeeaave!');
		//	this.$el.classList.add('-inaktiverad-med-full-opacitet', '-visa-spinner');

		//	// undefined = visa inget meddelande:
		//	e.returnValue = undefined;
		//	return undefined;
		//},

		//onAccountInput(x) {
		//	//console.log(x);
		//},
		//onAccountEnter(x) {
		//	alert('Enter: ' + x);
		//},

		onValueSelected(snabbval) {
			//console.log('Snabbval ' + x);

			this.AjaxpostaOchHanteraResultat('/snabbval', {
				formData: objectToFormData({ snabbval: snabbval }),
				//withoutSpinner: false,
				//doljSpinnerOnSuccess: false,
				//onFailureFunction: undefined,
				//onCatchedErrorFunction: undefined,
				onSuccessFunction: (resultat) => {

					// Gå till den hittade sidan:
					this.avbrytPollningen();
					window.location.href = resultat.CustomData;
				},
			});

			//axios.get('/snabbval?snabbval=' + snabbval)
			//	.then(response => {
			//		if (response.data.error === false) {
			//			//console.log('snabbval.response.data.url:' + response.data.url);

			//			// Hm.. denna hinner antagligen inte träda in, eftersom omrenderingar av sidan antagligen stoppas direkt när navigering initieras:
			//			this.sidanInaktiveradMedFullOpacitetOchSpinnerVisasEfterXs = true;
			//			this.avbrytPollningen();
			//			window.location.href = response.data.url;
			//		}
			//		else {
			//			// Det sket sig
			//			alert('Felaktigt snabbval');
			//		}
			//	})
			//	.catch(e => {
			//		// 1) errors är inte definierad under data (eller på annat sätt för 'this'), b) Namnet 'errors' riskerar att krocka med VeeValidate. Undvik!
			//		// this.errors.push(e);
			//		console.error(e);
			//	})
		},

		onMenyalternativValtIAnvandarmenyn({ eventId, eventData }) {
			switch (eventId) {
				case 'loggaUt':
					{
						// Nedanstående behövs för att vue-komponenten äter upp klick/toggling och då släcks inte eventuella synliga tooltips:
						ssoTooltips.doljAlla();

						//axios.post('/konto/logga-ut', new FormData())
						//	.then((response) => {
						//		// Här går vi till inloggningssidan:
						//		this.avbrytPollningen();
						//		window.location.href = '/konto/logga-in';
						//	})
						//	.catch((error) => {
						//		console.error(error);
						//	});

						// Hm.. denna hinner antagligen inte träda in, eftersom omrenderingar av sidan antagligen stoppas direkt när navigering initieras:
						this.sidanInaktiveradMedFullOpacitetOchSpinnerVisasEfterXs = true;

						// Stäng av redigeraläget (bara för att inte ha ett förvillande värde i session storage, sätts även vid inloggning):
						this.arIRedigeralage = false;

						this.avbrytPollningen();
						window.location.href = '/konto/logga-ut';
						break;
					}

				case 'reloadCache':
					{
						// Nedanstående behövs för att vue-komponenten äter upp klick/toggling och då släcks inte eventuella synliga tooltips:
						ssoTooltips.doljAlla();

						axios.post('/clearcache', new FormData())
							.then(response => {
								//? Ev testa respons här?
								this.avbrytPollningen();
								window.location.reload(true);
							})
							.catch(e => {
								console.error(e);
							});

						break;
					}

				case 'reloadCache2':
					{
						// Nedanstående behövs för att vue-komponenten äter upp klick/toggling och då släcks inte eventuella synliga tooltips:
						ssoTooltips.doljAlla();

						axios.post('/clearcachebrutal', new FormData())
							.then(response => {
								//? Ev testa respons här?
								this.avbrytPollningen();
								window.location.reload(true);
							})
							.catch(e => {
								console.error(e);
							});

						break;
					}

				case 'om':
					{
						// Nedanstående behövs för att vue-komponenten äter upp klick/toggling och då släcks inte eventuella synliga tooltips:
						ssoTooltips.doljAlla();

						this.visaMeddelandedialogOm = true;
						break;
					}
			}
		},

		onMenyalternativValtIImpersoneringsmenyn({ eventId, eventData }) {
			switch (eventId) {
				case 'inimpersonate':
					{
						// Nedanstående behövs för att vue-komponenten äter upp klick/toggling och då släcks inte eventuella synliga tooltips:
						ssoTooltips.doljAlla();

						this.AjaxpostaOchHanteraResultat('/inimpersonate', {
							formData: new FormData(),
							//doljSpinnerOnSuccess: false,
							onSuccessFunction: (resultat) => {

								// Gå till översiktssidan
								this.avbrytPollningen();
								window.location.href = '/';
							},
						});

						break;
					}
			}
		},

		onMenyalternativValtIAnnanMeny({ eventId, eventData }) {
			switch (eventId) {
				case 'valjLicens':
					{
						const licenseId = eventData;	// För tydlighet.

						this.AjaxpostaOchHanteraResultat('/license-select', {
							formData: objectToFormData({ licenseId: licenseId }),
							//withoutSpinner: false,
							//doljSpinnerOnSuccess: false,
							//onFailureFunction: undefined,
							//onCatchedErrorFunction: undefined,
							onSuccessFunction: (resultat) => {

								// Gå till Översikt:
								this.avbrytPollningen();
								window.location.href = '/';
							},
						});

						break;
					}

				case 'valjForetag':
					{
						const companyId = eventData;	// För tydlighet.

						this.AjaxpostaOchHanteraResultat('/company-select', {
							formData: objectToFormData({ companyId: companyId }),
							//withoutSpinner: false,
							//doljSpinnerOnSuccess: false,
							//onFailureFunction: undefined,
							//onCatchedErrorFunction: undefined,
							onSuccessFunction: (resultat) => {

								// Gå till Översikt:
								this.avbrytPollningen();
								window.location.href = '/';
							},
						});

						break;
					}

				case 'valjRar':
					{
						const fiscalYearId = eventData;	// För tydlighet.

						this.AjaxpostaOchHanteraResultat('/fiscal-year-select', {
							formData: objectToFormData({ fiscalYearId: fiscalYearId }),
							//withoutSpinner: false,
							//doljSpinnerOnSuccess: false,
							//onFailureFunction: undefined,
							//onCatchedErrorFunction: undefined,
							onSuccessFunction: (resultat) => {

								// Gå till Översikt:
								this.avbrytPollningen();
								window.location.href = '/';
							},
						});

						break;
					}
			}
		},

		//onOvaljLicens() {
		//	axios.post('/Innehall/UnSelectLicense', objectToFormData({}))
		//		.then(response => {
		//			// Hm.. denna hinner antagligen inte träda in, eftersom omrenderingar av sidan antagligen stoppas direkt när navigering initieras:
		//			this.sidanInaktiveradMedFullOpacitetOchSpinnerVisasEfterXs = true;
		//			this.avbrytPollningen();
		//			window.location.href = '/'; // Go to start page
		//		})
		//		.catch(e => {
		//			console.error(e);
		//		});
		//},

		//onOvaljForetag() {
		//	axios.post('/Innehall/UnSelectCompany', objectToFormData({}))
		//		.then(response => {
		//			// Hm.. denna hinner antagligen inte träda in, eftersom omrenderingar av sidan antagligen stoppas direkt när navigering initieras:
		//			this.sidanInaktiveradMedFullOpacitetOchSpinnerVisasEfterXs = true;
		//			this.avbrytPollningen();
		//			window.location.href = '/'; // Go to start page
		//		})
		//		.catch(e => {
		//			console.error(e);
		//		});
		//},

		//onOvaljRakar() {
		//	axios.post('/Innehall/UnSelectFiscalYear', objectToFormData({}))
		//		.then(response => {
		//			// Hm.. denna hinner antagligen inte träda in, eftersom omrenderingar av sidan antagligen stoppas direkt när navigering initieras:
		//			this.sidanInaktiveradMedFullOpacitetOchSpinnerVisasEfterXs = true;
		//			this.avbrytPollningen();
		//			window.location.href = '/'; // Go to start page
		//		})
		//		.catch(e => {
		//			console.error(e);
		//		});
		//},

		//==================================================================================================================

		onLaggTillOverstPaDialogstacken(uniktIdNr) {

			// Själva ändringen av stacken måste ske *här*, för concurrency, *inte* i dialogkomponenten:

			// Lägg dialogen överst på stacken:
			this.dialogStack.push(uniktIdNr);

			//console.log('Ny stack:', JSON.stringify(this.dialogStack));
		},

		onTaBortFranDialogstacken(uniktIdNr) {

			// Själva ändringen av stacken måste ske *här*, för concurrency, *inte* i dialogkomponenten:

			// Ta bort dialogen från stacken:
			this.dialogStack = this.dialogStack.filter((d) => { return d !== uniktIdNr; });

			//console.log('Ny stack:', JSON.stringify(this.dialogStack));
		},

		onLaggTillOverstPaMenystacken(uniktIdNr) {
			//console.log('onLaggTillOverstPaMenystacken', `[${uniktIdNr}]`);

			// Själva ändringen av stacken måste ske *här*, på rotmenyn, för concurrency, *inte* i undermenyer:

			// Lägg menyn överst på stacken:
			this.popUpMenyStack.push(uniktIdNr);

			//console.log('   +---> ny stack:', JSON.stringify(this.popUpMenyStack));
		},

		onTaBortFranMenystacken(uniktIdNr) {
			//console.log('onTaBortFranMenystacken', `[${uniktIdNr}]`);

			// Själva ändringen av stacken måste ske *här*, på rotmenyn, för concurrency, *inte* i undermenyer:

			// Ta bort menyn från stacken:
			this.popUpMenyStack = this.popUpMenyStack.filter((d) => { return d !== uniktIdNr; });

			//console.log('   +---> ny stack:', JSON.stringify(this.popUpMenyStack));
		},

		onMeddelandedialogStangsHanteratAvMixin(dialogId) {
			switch (dialogId) {
				//case 'innanNavigeringTillInloggningssidan':
				//	{
				//		// Navigera till inloggningssidan:
				//		// SKIPPAT: (inkl utloggning före om man är inloggad!):

				//		// Hm.. denna hinner antagligen inte träda in, eftersom omrenderingar av sidan antagligen stoppas direkt när navigering initieras:
				//		this.sidanInaktiveradMedFullOpacitetOchSpinnerVisasEfterXs = true;

				//		// Man kommer direkt till startsidan om man redan är inloggad!
				//		this.avbrytPollningen();
				//		window.location.href = '/';	//'/konto/logga-in';
				//		break;
				//	}

				case 'innanOmladdningAvSidan':
					{
						// Ladda om sidan (specialfall):

						// Hm.. denna hinner antagligen inte träda in, eftersom omrenderingar av sidan antagligen stoppas direkt när navigering initieras:
						this.sidanInaktiveradMedFullOpacitetOchSpinnerVisasEfterXs = true;

						this.avbrytPollningen();
						window.location.reload(true);
						break;
					}

				case 'om':
					{
						this.visaMeddelandedialogOm = false;
						break;
					}

				default:
					this.$root.$emit('meddelandedialog-stangs', dialogId);

					break;
			}
		},

		createPopUpMenus() {

			//console.log('## createPopUpMenus');

			if (this.licenses) {
				let menydelarLicens = [];

				//for (const license of this.licensesExceptSelected)
				for (const license of this.licenses) {
					let alt = new euiPopUpMenyClasses.delEvent(license.LicenseOwnersNameAndLicenseNumber, 'valjLicens',
						{ ikon: 'license', eventData: license.Id, checked: license.Id === this.selectedLicenseId });
					menydelarLicens.push(alt);
				}

				this.menyLicens = new euiPopUpMenyClasses.menyConfig(menydelarLicens);
			}
			// ----------------------------------------------------------------------------------------------


			if (this.companies) {
				let menydelarForetag = [];

				//for (const company of this.companiesExceptSelected)
				for (const company of this.companies) {
					let alt = new euiPopUpMenyClasses.delEvent(company.Name, 'valjForetag',
						{ ikon: 'foretag', eventData: company.Id, checked: company.Id === this.selectedCompanyId });
					menydelarForetag.push(alt);
				}

				this.menyForetag = new euiPopUpMenyClasses.menyConfig(menydelarForetag);
			}
			else {
				this.menyForetag = undefined;

			}


			// ----------------------------------------------------------------------------------------------

			if (this.fiscalYears) {
				let menydelarRar = [];

				//for (const fiscalYear of this.fiscalYearsExceptSelected)
				for (const fiscalYear of this.fiscalYears) {
					let alt = new euiPopUpMenyClasses.delEvent(fiscalYear.Presentation, 'valjRar',
						{ ikon: 'rakenskapsar', eventData: fiscalYear.Id, checked: fiscalYear.Id === this.selectedFiscalYearId });
					menydelarRar.push(alt);
				}

				this.menyRar = new euiPopUpMenyClasses.menyConfig(menydelarRar);
			}
			else {
				this.menyRar = undefined;
			}


			// ----------------------------------------------------------------------------------------------

			let menydelarAnvandare = [];

			menydelarAnvandare.push(new euiPopUpMenyClasses.delLinje());
			menydelarAnvandare.push(new euiPopUpMenyClasses.delLank('Min profil', '/installningar/min-profil', { ikon: 'anvandare' }));

			if (this.isAdministrator
				|| this.isSupportPerson) {
				menydelarAnvandare.push(new euiPopUpMenyClasses.delLank('Inställningar', '/installningar', { ikon: 'installningar' }));
			}
			if (this.isSupportPerson) {
				menydelarAnvandare.push(new euiPopUpMenyClasses.delLank('Statistik', '/statistik', { ikon: 'stapeldiagram' }));
			}

			menydelarAnvandare.push(new euiPopUpMenyClasses.delLinje());
			//menydelarAnvandare.push(new euiPopUpMenyClasses.delKomponent('sso-testkomponent'));
			menydelarAnvandare.push(new euiPopUpMenyClasses.delEvent('Logga ut', 'loggaUt', { ikon: 'loggaUt', cssModifierClass: '-fara' }));

			if (this.isSupportPerson) {
				menydelarAnvandare.push(new euiPopUpMenyClasses.delLinje());
				menydelarAnvandare.push(new euiPopUpMenyClasses.delEvent('Töm cache och ladda om sidan', 'reloadCache', { ikon: 'kryss', cssModifierClass: '-varning' }));
				menydelarAnvandare.push(new euiPopUpMenyClasses.delEvent('Töm cache brutalt', 'reloadCache2', { ikon: 'kryss', cssModifierClass: '-fara' }));
				menydelarAnvandare.push(new euiPopUpMenyClasses.delLinje());
				menydelarAnvandare.push(new euiPopUpMenyClasses.delLank('Systeminformation', '/systeminfo', { ikon: 'hanglasUpplast', cssModifierClass: '-varning' }));
				menydelarAnvandare.push(new euiPopUpMenyClasses.delLank('Användare', '/userlist', { ikon: 'hanglasUpplast', cssModifierClass: '-varning' }));
				menydelarAnvandare.push(new euiPopUpMenyClasses.delLank('MiniProfiler – senaste anropet', '/mini-profiler-resources/results', { ikon: 'hanglasUpplast', cssModifierClass: '-varning' }));
				menydelarAnvandare.push(new euiPopUpMenyClasses.delLank('MiniProfiler – 100 senaste', '/mini-profiler-resources/results-index', { ikon: 'hanglasUpplast', cssModifierClass: '-varning' }));
				menydelarAnvandare.push(new euiPopUpMenyClasses.delLank('Systemloggen', '/log', { ikon: 'hanglasUpplast', cssModifierClass: '-varning', nyttFonster: true }));
				menydelarAnvandare.push(new euiPopUpMenyClasses.delLank('Cacheinnehåll', '/cache', { ikon: 'hanglasUpplast', cssModifierClass: '-varning', nyttFonster:true }));
				menydelarAnvandare.push(new euiPopUpMenyClasses.delLank('Användarräknare', '/usercount', { ikon: 'hanglasUpplast', cssModifierClass: '-varning', nyttFonster:true }));
				menydelarAnvandare.push(new euiPopUpMenyClasses.delLank('Hangfire dashboard', '/hangfire', { ikon: 'hanglasUpplast', cssModifierClass: '-varning' }));
			}

			menydelarAnvandare.push(new euiPopUpMenyClasses.delLinje());
			menydelarAnvandare.push(new euiPopUpMenyClasses.delLank('Hjälp', '/hjalp', { ikon: 'frageteckenCirkel' }));
			menydelarAnvandare.push(new euiPopUpMenyClasses.delEvent('Om…', 'om', { ikon: 'om' }));

			this.menyAnvandare = new euiPopUpMenyClasses.menyConfig(menydelarAnvandare);
		},

		AjaxpostaOchHanteraResultat(url,
			// Named and optional parameters (med eventuella default satta), as options object:
			{
				formData = new FormData(),				// Tomma data
				withoutSpinner = false,
				doljSpinnerOnSuccess = false,			// Default = nej. Måste då vid behov döljas i onSuccessFunction(), men rekommenderas att man struntar i om sidnavigering också görs i den.
				onFailureFunction = undefined,		// Om satt: *istället* för att visa felmeddelandet.
				onCatchedErrorFunction = undefined,	// Om satt: *istället* för att visa ajax-felmeddelandet.
				onSuccessFunction = undefined,
			}
				= {}	// Default för den optional options-parametern som sådan.
		) {
			if (!withoutSpinner)
				this.sidanInaktiveradMedFullOpacitetOchSpinnerVisasEfterXs = true;

			axios.post(url, formData)
				.then(response => {

					const resultat = Resultat.castFrom(response.data);

					if (resultat.Failed) {
						if (!withoutSpinner)
							this.sidanInaktiveradMedFullOpacitetOchSpinnerVisasEfterXs = false;

						// Servern returnerade ett fel (validering/tekniskt/...):

						// Anropa ev callback *istället* för att visa felet:
						if (onFailureFunction) {
							onFailureFunction(resultat);
						}
						else {
							// Visa det:
							this.visaResultatmeddelande(resultat);
						}
					}
					else {
						// Allt ok:
						if (!withoutSpinner && doljSpinnerOnSuccess)
							this.sidanInaktiveradMedFullOpacitetOchSpinnerVisasEfterXs = false;

						// Anropa ev callback:
						if (onSuccessFunction)
							onSuccessFunction(resultat);
					}
				})
				.catch(error => {
					// Ett axios-fel har uppstått:

					// Anropa ev callback *istället* för att visa felet:
					if (onCatchedErrorFunction) {
						onCatchedErrorFunction(error);
					}
					else {
						// Visa det (och stå kvar i dialogen):
						this.sidanInaktiveradMedFullOpacitetOchSpinnerVisasEfterXs = false;
						this.visaAxiosFelmeddelande(error);
					}
				});
		},
	},



	//== Lifecycle hooks  ================================================================================================================

	beforeCreate() {
		// Deklaration av "private" variabler, som är "non reactive properties of this instance" (ett alt sätt är att anv data, men sätta värdet till Object.freeze(värde)):
		// Exempel: this.$_undertryckNastaAndradEvent = false;

		// Media query stuff:
		// https://developer.mozilla.org/en-US/docs/Web/CSS/Media_Queries/Testing_media_queries
		// Här deklareras en "private" variabel, som är "non reactive property of this instance":
		this.$_mediaQueryListSmaltFonster = window.matchMedia(window.ssoRamverk.mediaQueryForSmalSkarm); // Create the query list.

		// Defaultvärde, som kan skrivas över i enskilda appar som använder denna mixin:
		this.$_rullningsbaraElementQuerySelectorAll = '.-rullningsbar-auto, .-rullningsbar-overlay, .-rullningsbar-auto-persist, .-rullningsbar-overlay-persist';


		//---------------------------------------------------------------------------------------------------------------

		// Ställ in så att *alla* Axios.post med data av typen FormData skickar med header med AntiForgeryToken:
		// Obs! Don't forget to add @Html.AntiForgeryToken() to your view or this will be empty!

		// Ändra global axios defaults:
		//axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';		// Form data, *inte* json-objekt, för att [ValidateAntiForgeryToken] på controllern ska funka (tror jag).
		//const formData = new FormData();
		//formData.append('__RequestVerificationToken', antiForgeryToken);
		//axios.defaults.data = formData;

		//(configgen) {
		//	// `transformRequest` allows changes to the request data before it is sent to the server
		//	// This is only applicable for request methods 'PUT', 'POST', and 'PATCH'
		//	// The last function in the array must return a string or an instance of Buffer, ArrayBuffer,
		//	// FormData or Stream
		//	// You may modify the headers object.
		//	transformRequest: [
		//		(data, headers) => {
		//			// Do whatever you want to transform the data

		//			data.dimmi = 'dimmi';

		//			return data;
		//		}
		//	],
		//}

		// Add a request interceptor
		// https://github.com/axios/axios#interceptors
		// qs används för att gå runt ett problem med att den satta 'Content-Type' tas bort/ändras till 'application/json', typ:
		// https://github.com/axios/axios/issues/362#issuecomment-265832242

		axios.interceptors.request.use(
			(config) => {
				// Do something before request is sent:

				// Lägger alltid på denna för att på ett säkert sätt kunna detektera Ajax-anrop server side:
				// OBS!!!!!! Server side kod förlitar sig på denna!!!!!!
				//config.headers = { Authorization: `Bearer ${accessToken}`, 'X-TenantId': X_TENAT_ID};
				config.headers['X-Requested-With'] = 'XMLHttpRequest';

				if (config.method === 'post') {
					// Om det är en POST:

					// Denna har utgått i interceptorn = man måste själv skicka med ett "tomt" FormData-objekt om man vill ha tillagt en antiForgeryToken:
					//// Om data som ska postas är "null":
					//config.data = config.data || new FormData();

					if (config.data && config.data instanceof FormData) {
						// Data finns och de är i FormData-format:

						// Lägg till antiForgeryToken:

						// Grab antiForgeryToken:
						// Obs! Görs på nytt vid *varje* ny POST, för den *kan* ha ändrats:
						const antiForgeryToken = document.querySelector('input[name=__RequestVerificationToken]').value;

						// "The set() method of the FormData interface sets a new value for an existing key inside a FormData object, or adds the key/value if it does not already exist."
						config.data.set('__RequestVerificationToken', antiForgeryToken);

						//config.headers.post['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';		// Form data, *inte* json-objekt, för att [ValidateAntiForgeryToken] på controllern ska funka (tror jag).
						//// `headers` are custom headers to be sent
						//headers: {'X-Requested-With': 'XMLHttpRequest'},

						//if (config.data && config.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
						//	config.data = qs.stringify(config.data);
						//}
					}
					else {
						const feltext = 'axios.post med data av annan typ än FormData (eller null/undefined).';
						console.error(feltext);
					}
				}

				return config;
			},
			//(error) => {
			//	// Do something with request error
			//	return Promise.reject(error);
			//}
		);
	},

	created() {
		// Called synchronously after the instance is created. At this stage, the instance has finished processing the options which means the following have been set up: data observation, computed properties, methods, watch/event callbacks. However, the mounting phase has not been started, and the $el property will not be available yet.

		// Lek ;)
		console.log(
			'%c Siffersurfaren Online %c Version ' + this.appVersion + ' %c',
			'background:#35495e ; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff',
			'background:#E393A9 ; padding: 1px; border-radius: 0 3px 3px 0;  color: #fff',
			'background:transparent'
		);

		this.createPopUpMenus();

		// Slå på uppdatering av menyalternativen - sker tills vidare genom polling
		if (!this.disableRichContextPoll) {
			this.pollTimer = setInterval(this.pollContext, 5000);		// ~3000 ms är förmodligen ett rimligt lägsta "tät-pollning-intervall".
		}
	},

	//beforeMount()
	//{
	//	// Called right before the mounting begins: the render function is about to be called for the first time.
	//	// This hook is not called during server-side rendering.
	//	// Detta är hooken efter att Vues kompilering är klar. v-cloak är fortfarande kvar, men plockas bort strax efter denna körts.
	//	// Här är det inte lämpligt att förändra DOM, för den ersätts vid den stundande renderingen och då tappas ändringarna (är jag ganska säker på).
	//},

	mounted() {
		// Note that mounted does not guarantee that all child components have also been mounted.

		//-----------------------------------------------------------------------------------------------------------------------
		// Mixin hooks will be called *before* the component’s/app’s own hooks. Ordning:
		//
		// 1. Mixins mounted hook.
		// 2. Appens/komponentens mounted hook.
		//
		// 3. Mixins mounted hook + nextTick (DOM not updated yet).
		// 4. Appens/komponentens mounted hook + nextTick (DOM not updated yet).
		//
		// 5. Mixins mounted hook + nextTick (DOM not updated yet) + ytterligare ett Vue.nextTick (DOM updated).
		// 6. Appens/komponentens mounted hook + nextTick (DOM not updated yet) + ytterligare ett Vue.nextTick (DOM updated).
		//
		// Det är *först efter steg 4* ovan som allt är färdigrenderat, med avseende på Vue-grejs som exempelvis all reaktivitet som förekommer i appen (ex visa/dölj element)!
		//
		// Alltså, saker som ska göras i denna mixins mounted och som ska ske *efter* steg 2 ovan:
		// a) kan göras som steg 3 ovan, *om* det *inte* är beroende av att allt reaktivt är garanterat färdigrenderat eller
		// b) måste göras som steg 5 ovan, *om* det är beroende av att allt reaktivt är garanterat färdigrenderat.
		//-----------------------------------------------------------------------------------------------------------------------

		//## 1. Mixins mounted hook:  #################################
		//console.log('1. Mixins mounted hook');

		//this.$el.classList.remove('-inaktiverad-med-full-opacitet', '-visa-spinner');

		// Programmatisk bind:
		this.$on('lagg-till-overst-pa-dialogstacken', this.onLaggTillOverstPaDialogstacken);
		this.$on('ta-bort-fran-dialogstacken', this.onTaBortFranDialogstacken);

		this.$on('lagg-till-overst-pa-menystacken', this.onLaggTillOverstPaMenystacken);
		this.$on('ta-bort-fran-menystacken', this.onTaBortFranMenystacken);

		//! Obs! Det kan finnas flera bindningar till detta event, där ytterligare sådana är specifika för enskilda sidor:
		this.$on('meddelandedialog-stangs-for-hantering-i-mixin', this.onMeddelandedialogStangsHanteratAvMixin);


		// Media query stuff:
		// https://developer.mozilla.org/en-US/docs/Web/CSS/Media_Queries/Testing_media_queries
		this.$_mediaQueryListSmaltFonster.addListener(this.onSmaltFonsterAndrat); // Add the callback function as a listener to the query list.
		this.onSmaltFonsterAndrat(this.$_mediaQueryListSmaltFonster); // Run the orientation change handler once.

		//document.addEventListener('beforeunload', this.onBeforeUnload);

		this.$nextTick(function () {
			// Code that will run only after the entire Vue view has been rendered (= guarantee that all child components have also been mounted):
			// This is the same as the global Vue.nextTick, except that the callback’s this context is automatically bound to the instance calling this method:

			//## 3. Mixins mounted hook + nextTick (DOM not updated yet):  #################################
			//console.log('3. Mixins mounted hook + nextTick (DOM not updated yet)');

			if (this.autovisaMeddelande)
				this.visaMeddelande(this.autovisaMeddelande);


			//---------------------------------------------------------------------------------------------------------------

			// Todo: Här nedan manipuleras DOM:en för komponenter (Snabbval, Sök...) direkt, trots att de är komponenter! Principiellt fel!! Det ska gå via komponenternas interface!!!

			this.snabbvalComponent = this.$refs.snabbvalComponent;
			this.sokComponent = this.$refs.sokComponent;

			//---------------------------------------------------------------------------------------------------------------

			// Todo: Delar av denna hantering borde DRYas och delas mellan olika generiska kryssrute-komponenter och inputs (euiSearchText.vue, euiAutocomplete...). I samband med det bör även access-keys "registreras" i central array med dubblettkontroll:

			// Hantera access-key för Snabbval (inkl dold-meny-hantering):

			if (!!this.snabbvalComponent && !!this.snabbvalComponent.vpAccessKey && this.snabbvalComponent.vpAccessKey !== '') {
				document.addEventListener('keydown', (e) => {

					//if (!this.vpInaktiverad)
					//{
					//	// Obs! Access key ska inte funka då kryssrutan är inaktiverad med propen vpInaktiverad. *Dock* så fungerar den även om kryssrutan är disabled (HTML-attribut). Egentligen är det fel, men vi har det så tills vidare, för att man ska kunna accessa kryssrutor även i dold meny (som disablear element med direktivet "eui-maintain-disabled"):

					if (e.defaultPrevented) {
						return; // Do nothing if the event was already processed
					}

					if (//&& (e.target.tagName === 'BODY' || e.target.tagName === 'DIV')
						//&&
						!e.repeat
					) {
						//console.log(e);
						//console.log(`Tangent: key="${e.key}", keycode=${e.keyCode}, key.charCodeAt(0)=${e.key.charCodeAt(0)}  ---  vpAccessKey=${this.vpAccessKey}, vpAccessKey.toLowerCase()).charCodeAt(0)=${(this.vpAccessKey.toLowerCase()).charCodeAt(0)}`);

						if (e.altKey		// YES! Alt + ..
							&& !e.ctrlKey	// NO! Ctrl + ..
							&& e.key.length === 1		// För att utesluta "ArrowDown" o.d.
							&& e.key.charCodeAt(0) === (this.snabbvalComponent.vpAccessKey.toLowerCase()).charCodeAt(0)	// "key" omvandlad till "extended ascii"-koder
						) {
							// AccessKeyen tryckt:
							//console.log('HIT!!!');

							if (this.menynArStangd) {

								// Nej, inte längre (kommentaren nedan)!
								//x Detta öppnande av menyn gör även autofocus på Snabbval:
								this.doldMenyArOppnad = true;

								// Invänta, så att ovan hinner slå igenom (menyn visas och textrutan bli enablead):
								Vue.nextTick(function () {
									this.fokuseraInputruta(this.snabbvalComponent.$refs.input);
									this.selectaAlltIInputruta(this.snabbvalComponent.$refs.input);
								}
									, this	// Vue.nextTick 'this' context.
								);

								//setTimeout(function() {
								//		input.focus();
								//	}
								//	, 200	// ms
								//);
							}
							else {
								this.fokuseraInputruta(this.snabbvalComponent.$refs.input);
								this.selectaAlltIInputruta(this.snabbvalComponent.$refs.input);
							}
						}
					}
					//}
				});
			}

			//---------------------------------------------------------------------------------------------------------------

			// Hantera access-key för Sök (inkl dold-meny-hantering):

			if (!!this.sokComponent && !!this.sokComponent.vpAccessKey && this.sokComponent.vpAccessKey !== '') {
				document.addEventListener('keydown', (e) => {

					//if (!this.vpInaktiverad)
					//{
					//	// Obs! Access key ska inte funka då kryssrutan är inaktiverad med propen vpInaktiverad. *Dock* så fungerar den även om kryssrutan är disabled (HTML-attribut). Egentligen är det fel, men vi har det så tills vidare, för att man ska kunna accessa kryssrutor även i dold meny (som disablear element med direktivet "eui-maintain-disabled"):

					if (e.defaultPrevented) {
						return; // Do nothing if the event was already processed
					}

					if (//&& (e.target.tagName === 'BODY' || e.target.tagName === 'DIV')
						//&&
						!e.repeat
					) {
						//console.log(e);
						//console.log(`Tangent: key="${e.key}", keycode=${e.keyCode}, key.charCodeAt(0)=${e.key.charCodeAt(0)}  ---  vpAccessKey=${this.vpAccessKey}, vpAccessKey.toLowerCase()).charCodeAt(0)=${(this.vpAccessKey.toLowerCase()).charCodeAt(0)}`);

						if (e.altKey		// YES! Alt + ..
							&& !e.ctrlKey	// NO! Ctrl + ..
							&& e.key.length === 1		// För att utesluta "ArrowDown" o.d.
							&& e.key.charCodeAt(0) === (this.sokComponent.vpAccessKey.toLowerCase()).charCodeAt(0)	// "key" omvandlad till "extended ascii"-koder
						) {
							// AccessKeyen tryckt:
							//console.log('HIT!!!');

							if (this.menynArStangd) {

								this.doldMenyArOppnad = true;

								// Invänta, så att ovan hinner slå igenom (menyn visas och textrutan bli enablead):
								Vue.nextTick(function () {
									this.fokuseraInputruta(this.sokComponent.$refs.input);
									this.selectaAlltIInputruta(this.sokComponent.$refs.input);
								}
									, this	// Vue.nextTick 'this' context.
								);

								//setTimeout(function() {
								//		input.focus();
								//	}
								//	, 200	// ms
								//);
							}
							else {
								this.fokuseraInputruta(this.sokComponent.$refs.input);
								this.selectaAlltIInputruta(this.sokComponent.$refs.input);
							}
						}
					}
					//}
				});
			}

			//---------------------------------------------------------------------------------------------------------------

			if (this.snabbvalComponent) {
				// Hantera vissa tangenttryck, då någon input *inte* redan har fokus:
				// Komplex fråga om man ska vara noga, men det är vi inte ;)  (se https://hacks.mozilla.org/2017/03/internationalize-your-keyboard-controls/).
				// Inkl dold-meny-hantering:
				document.addEventListener('keydown', (e) => {

					if (e.defaultPrevented) {
						return; // Do nothing if the event was already processed
					}

					if ((e.target.tagName === 'BODY' || e.target.tagName === 'DIV')
						&& !e.repeat
						&& !e.ctrlKey && !e.altKey
						&& e.key.length === 1		// För att utesluta "ArrowDown" o.d.
						&& e.key.charCodeAt(0) >= 33 && e.key.charCodeAt(0) <= 254	// "key" omvandlad till "extended ascii"-koder
					) {
						//console.log(e);
						//console.log(`Tangent: key="${e.key}", keycode=${e.keyCode}, key.charCodeAt(0)=${e.key.charCodeAt(0)}`);

						//let input = document.querySelector('input[name=\x27snabbval\x27]');

						if (this.menynArStangd) {

							// Nej, inte längre (kommentaren nedan)!
							//x Detta öppnande av menyn gör även autofocus på Snabbval:
							this.doldMenyArOppnad = true;

							// Invänta, så att ovan hinner slå igenom (menyn visas och snabbvalsrutan bli enablead):
							Vue.nextTick(function () {
								this.tomInputruta(this.snabbvalComponent.$refs.input);
								this.fokuseraInputruta(this.snabbvalComponent.$refs.input);
							}
								, this	// Vue.nextTick 'this' context.
							);

							//setTimeout(function() {
							//		input.focus();
							//	}
							//	, 200	// ms
							//);
						}
						else {
							this.tomInputruta(this.snabbvalComponent.$refs.input);
							this.fokuseraInputruta(this.snabbvalComponent.$refs.input);
						}
					}
				});
			}

			//---------------------------------------------------------------------------------------------------------------

			Vue.nextTick(() => {

					//## 5. Mixins mounted hook + nextTick (DOM not updated yet) + ytterligare ett Vue.nextTick (DOM updated):  #################################
					//console.log('5. Mixins mounted hook + nextTick (DOM not updated yet) + ytterligare ett Vue.nextTick (DOM updated)');

					// Initiera tooltips:
					ssoTooltips.initiera(this.$el);
					// Flyttad till if-satsen nedan: ssoTooltips.doljAllaNarInnehalletRullas(this.$_rullningsbaraElementQuerySelectorAll);


					//--------------------------------------------------------------------------------------------------------

					if (this.$_rullningsbaraElementQuerySelectorAll) {
						// Om något/några rullningsbara element är definierade för appen (via den "privata" variabeln med namnet $_rullningsbaraElementQuerySelectorAll):

						for (const element of document.querySelectorAll(this.$_rullningsbaraElementQuerySelectorAll)) {
							// För varje rullningsbart element:

							// Initiera en scroll-event-lyssnare för tooltips:
							ssoTooltips.doljAllaNarInnehalletRullas(element);

							if (this.$_vuexNamespace
								&& element.elementId !== '') {
								// Två krav för att persistens av scrollTop ska aktiveras/hanteras:
								// 1. $_vuexNamespace har satts (förutom $_rullningsbaraElementQuerySelectorAll dårå).
								// 2. Man har satt ett id-attribut på elementet också (somm stämmer med det id som angetts i sidans statestore-modul).
								// Avsaknaden av någon av dessa tolkas som ett aktivt val att det rullningsbara elementet *inte* ska persisteras, tyrots att class(er) för detta satts!

								// Hantera persistensen av scrollTop:

								console.time('#TIMING: Hantera persistensen av rullningsläge');	// Todo: TEMP!!!

								if (NavigatedWithBackOrForward()) {
									// Återställ scrolläget till persisterat värde:
									element.scrollTop = this.$store.state[this.$_vuexNamespace]
										.rullningsbaraElement
										.find(x => x.id === element.id)
										.scrollTop;
								}
								else {
									// "Nollställ" det persisterade värdet:
									//this.$store.commit(this.$_vuexNamespace + '/setScrollTop', { id: element.id, scrollTop: 0 });
									this.persisteraScrollTop(this, element);
								}

								// Bevaka scroll-event och persistera värden:
								// Since scroll events can fire at a high rate, the event handler shouldn't execute computationally expensive operations such as DOM modifications. Instead, it is recommended to throttle the event:

								// _.throttle doesn't actually take four arguments. Only three. So your component is being ignored. If you want to pass it in as the argument to persistera, you could use lodash's _.partial function, or use an anonymous function: "() => persistera(a, b)":
								// https://stackoverflow.com/a/46983920/593779
								element.addEventListener('scroll',
									throttla(() => this.persisteraScrollTop(this, element),
										300,	// Så lång throttlingstid i ms.
										{ trailing: true, leading: false }	// Setting the leading to true will begin callback execution immediately and then throttle. When you set *both* leading and trailing to true, this guarantees execution per interval.
									),
									false
								);

								console.timeEnd('#TIMING: Hantera persistensen av rullningsläge');	// Todo: TEMP!!!
							}
						}
					}


					//--------------------------------------------------------------------------------------------------------

					// Initiera SSE (Server Side Events):

					//++ Denna test är urkopplad. Se SseController.cs:
					////////this.$_source = new EventSource('sse/message');

					////////// source har dessa medlemmar:
					//////////onerror: null
					//////////onmessage: null
					//////////onopen: null
					//////////readyState: 0
					//////////url: "https://localhost:44302/sse/message"
					//////////withCredentials: false

					////////this.$_source.onerror = (err) => {
					////////	console.error('EventSource failed:', err);
					////////};

					////////this.$_source.onmessage = (e) => {
					////////	this.$root.sseData = JSON.parse(e.data);

					////////	console.log('SSE timestamp:', this.$root.sseData.timestamp);
					////////	console.log('SSE resultat:', this.$root.sseData.resultat);
					////////};
				}
				, this	// Vue.nextTick 'this' context.
			);

		});
	},

	beforeDestroy() {
		if (this.$_source)
			this.$_source.close();

		// Media query stuff:
		// https://developer.mozilla.org/en-US/docs/Web/CSS/Media_Queries/Testing_media_queries
		this.$_mediaQueryListSmaltFonster.removeListener(this.onSmaltFonsterAndrat);

		// Stäng av autouppdatering av menyalternativ
		this.avbrytPollningen();
	}
};

export { mixin as ssoAllaSidorMixin };
